import { gsap } from './gsap';

const borderReveal = () => {
  const borders = gsap.utils.toArray('.border-reveal:not(.header .border-reveal)');
  if (borders.length > 0) {
    borders.forEach((border) => {
      let setToggleActions = 'play reverse play reset';
      if (border.classList.contains('tween-once')) {
        setToggleActions = 'play none none none';
      }
      gsap.to(border, {
        duration: 1.5,
        '--border-width': '100%',
        stagger: 0.15,
        scrollTrigger: {
          trigger: border,
          start: '70% bottom',
          toggleActions: setToggleActions,
        }
      });
    });
  }
};

export default borderReveal;
